import axios from 'axios'
import Qs from 'qs'

axios.interceptors.request.use(config => {
  config.paramsSerializer = params => {
    return Qs.stringify(params, {
      arrayFormat: 'brackets',
      encode: false
    })
  }

  return config
})

axios.defaults.headers =  {
  "accept": "application/json, text/plain, */*",
}

export default axios



// WEBPACK FOOTER //
// ./src/http_client.js